module.exports = __webpack_public_path__ + "static/media/ionicons.b45d332f.svg";